import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Hero: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-red-50 to-white overflow-hidden">
      {/* Snowfall effect */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(50)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 bg-white rounded-full"
            animate={{
              y: ['0vh', '100vh'],
              x: [
                `${Math.random() * 100}vw`,
                `${Math.random() * 100 + (-10 + Math.random() * 20)}vw`
              ]
            }}
            transition={{
              duration: 5 + Math.random() * 5,
              repeat: Infinity,
              ease: 'linear',
              delay: Math.random() * 5
            }}
          />
        ))}
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl md:text-6xl font-bold text-gray-900 mb-6"
        >
          Bring Santa to Life This Christmas! 🎅✨
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto"
        >
          Create personalized Santa videos for your family, friends, or business—easy, magical, and unforgettable!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button 
            size="lg" 
            className="group"
            onClick={() => navigate('/get-started')}
          >
            <Gift className="w-5 h-5 mr-2 inline group-hover:rotate-12 transition-transform" />
            Get Started Now
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => {
              const howItWorks = document.getElementById('how-it-works');
              if (howItWorks) {
                howItWorks.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            See the magic in action!
          </Button>
        </motion.div>
      </div>
    </div>
  );
};